type LocationPartnerContact = {
  phone: string
  email: string
}

const LOCATION_PARTNER_CONTACTS: Record<string, LocationPartnerContact> = {
  SE: { phone: '+46 107 610 940', email: 'locations@instabee.com' },
  NO: { phone: '+46 107 610 940', email: 'locations@instabee.com' },
  DK: { phone: '+45 32 67 88 55', email: 'box.dk@instabee.com' },
}

export const getLocationPartnerContact = (marketCode: string): LocationPartnerContact =>
  LOCATION_PARTNER_CONTACTS[marketCode.toUpperCase()] ?? LOCATION_PARTNER_CONTACTS.SE

// The market's locations_email field in Directus holds either an email address or a form URL
export const getContactHref = (value?: string | null) =>
  value && /\S+@\S+\.\S+/.test(value) ? `mailto:${value}` : value
